module.exports = "https://cdn.dove.it/_next/static/public/assets/cities/small/lucca.bf7b536e27569a2514621983f9584b00.jpg";